import moment from 'moment-timezone';
moment.tz.setDefault('Europe/London');

export const checkOpeningTime = openingTimesArray => {
  const now = new Date();
  return openingTimesArray.some(date => {
    return new Date(date.from) < now && now < new Date(date.to);
  });
};

export const isRestaurantOpen = (openingTimes, modes, serverOffline) => {
  return openingTimes && !serverOffline && ((checkOpeningTime(openingTimes.delivery) && modes.delivery) || (checkOpeningTime(openingTimes.collection) && modes.collection));
};

export const getOpenButtonText = (openingTimes, modes, serverOffline) => {
  return isRestaurantOpen(openingTimes, modes, serverOffline) ? 'home.open' : (modes.futureOrders ? 'home.openForPreorder' : 'home.closed');
};

export const getOrderNowButtonText = (openingTimes, modes, serverOffline) => {
  return isRestaurantOpen(openingTimes, modes, serverOffline) ? 'home.orderNow' : (modes.futureOrders ? 'home.preorderMenu' : 'home.viewMenu');
};

const nextOpeningOrClosingTime = (openingTimesArray, isClosingTime) => {
  const time = isClosingTime ? 'to' : 'from';
  let outputNextOpeningTime = null;
  const now = new Date();
  for (const openingTime of openingTimesArray) {
    if (now < new Date(openingTime[time])) {
      outputNextOpeningTime = new Date(openingTime[time]);
      break;
    }
  }
  return outputNextOpeningTime;
};

export const getNextOpeningTime = (openingTimesObject, restaurantModes) => {
  const nextOpeningTimeCollection = !restaurantModes.collection ? null : nextOpeningOrClosingTime(openingTimesObject.collection);
  const nextOpeningTimeDelivery = !restaurantModes.delivery ? null : nextOpeningOrClosingTime(openingTimesObject.delivery);
  if (nextOpeningTimeCollection === null && nextOpeningTimeDelivery) {
    return nextOpeningTimeDelivery;
  } else if (nextOpeningTimeCollection && nextOpeningTimeDelivery === null) {
    return nextOpeningTimeCollection;
  } else {
    return nextOpeningTimeCollection < nextOpeningTimeDelivery ? nextOpeningTimeCollection: nextOpeningTimeDelivery;
  }
};

export const getOpeningsDetails = openings => {
  let result;
  const now = new Date();
  for (const opening of openings) {
    if (now > opening.from && now < opening.to) {
      result = opening;
      break;
    }
  }
  return result;
};

export const getNextOpeningsDetails = openings => {
  let result;
  const now = new Date();
  for (const opening of openings) {
    if (now < opening.from) {
      result = opening;
      break;
    }
  }
  return result;
};

export const getNextAvailableDay = times => {
  const now = moment();
  const today = now.weekday();
  let firstRound = true;
  let notOpenToday = false;
  let selectedDay = today;
  let availableTime = times[selectedDay];
  if (availableTime) {
    const filtered = availableTime.filter(time => {
      return moment(time, 'hh:mm A').isAfter(now);
    });
    if (filtered.length > 0) {
      return selectedDay;
    } else {
      notOpenToday = true;
    }
  }
  while (!availableTime && selectedDay < 8 || notOpenToday) {
    notOpenToday = false;
    if (selectedDay === today && !firstRound) {
      break;
    }
    selectedDay += 1;
    if (selectedDay > 7) {
      firstRound = false;
      selectedDay = 1;
    }
    availableTime = times[selectedDay];
  }

  return selectedDay;
};

export const filterPastTime = (times, date, weekday) => {
  const day = weekday === 0 ? 7 : weekday;
  if (!times[day]) {
    return [];
  }
  const now = moment();
  if (!date.isSame(now, 'day')) {
    return times[day];
  }
  const filtered = times[day].filter(time => {
    return moment(time, 'hh:mm A').isAfter(now);
  });
  return filtered;
};

export const getNextDate = day => {
  const now = moment();
  const today = now.weekday();
  let result;
  if (day === today) {
    result = now;
  } else if (day < today) {
    result = now.add(7 - today + day, 'days');
  } else {
    result = now.add(day - today, 'days');
  }
  return result;
};

export const isDayBlocked = (day, openingTimes) => {
  const now = moment();
  const today = now.isSame(day, 'day');
  const dateMod = today ? now : day.hours(0).minutes(1);

  for (let i = 0; i < openingTimes.length; i++) {
    if (dateMod.isSame(openingTimes[i].from, 'day') && !today ||
      today && dateMod.isBetween(openingTimes[i].from, openingTimes[i].to)
    ) {
      return false;
    }
  }
  return true;
};

export const roundNext15Min = time => {
  const span = 15 - time.minute() % 15;
  return moment(time).add(span, 'm');
};

export const calculateFutureOrdersTimeRange = (date, openingTimes, serviceType, restaurantCode) => {
  const ranges = [];
  const futureTimes = [];
  const dateMod = moment().isSame(date, 'day') ? moment() : date.hours(0).minutes(1);
  let currentTime;

  for (let index = 0; index < openingTimes[serviceType].length; index++) {
    const openingTime = openingTimes[serviceType][index];
    if (dateMod.isSame(moment(openingTime.from), 'day') && dateMod.isSameOrBefore(moment(openingTime.to))) {
      ranges.push({from: moment(openingTime.from), to: moment(openingTime.to)});
    }
  }

  if (dateMod.isSameOrAfter(ranges[0].from) && dateMod.isSame(moment(), 'day')) {
    futureTimes.push({ label: 'ASAP', value: 'ASAP'});
    currentTime = roundNext15Min(moment());
    currentTime.add(1, 'hour');
  } else if (restaurantCode === 'jjcafe'){
    currentTime = ranges[0].from;
  } else {
    currentTime = ranges[0].from.add(45, 'minutes');
  }

  for (let index = 0; index < ranges.length; index++) {
    const time = ranges[index];
    while (currentTime.isSameOrBefore(time.to)) {
      futureTimes.push({label: currentTime.format('h:mm a'), value: currentTime.format('HH:mm')});
      if (restaurantCode === 'jjcafe'){
        currentTime.add(15, 'm');
      } else {
        currentTime.add(30, 'm');
      }
    }

    if (index < ranges.length-1) {
      currentTime = ranges[index+1].from.add(45, 'minutes');
    }
  }

  return futureTimes;
};

export const calculateFutureOrdersStartingDate = (openingTimes, serviceType) => {
  if (checkOpeningTime(openingTimes[serviceType])) {
    return moment();
  } else {
    return moment(nextOpeningOrClosingTime(openingTimes[serviceType]));
  }
};

export const convertMonthTo1Based = times => {
  //TODO: quick fix for now but need to find a better solution
  if (!times && !Array.isArray(times)) {
    return null;
  }
  return Object.assign([], times, {1: times[1] - 1});
};

export const convertExceptionalTimeDay = (day, withoutYear) => {
  const monthNumber = day[1] < 10 ? `0${day[1]}` : day[1];
  const dayNumber = day[2] < 10 ? `0${day[2]}` : day[2];
  const formatDate = withoutYear ? 'MMM D' : 'MMM D, YYYY';
  return moment(`${day[0]}-${monthNumber}-${dayNumber}`).format(formatDate);
};

export const convertExceptionalTime = (time) => moment().hours(time[0]).minutes(time[1]).format('h:mmA');

export const getCurrentEta = openingTimes => {
  const now = new Date();
  return openingTimes.find(openingTime => (now > openingTime.from && now < openingTime.to));
};

export const isEqual = (array1, array2) => {
  // fastest compare, see https://stackoverflow.com/a/42186143
  let i = array1.length;
  while (i--) {
    if (array1[i] !== array2[i]) return false;
  }
  return true;
};



// WEBPACK FOOTER //
// ./helpers/date.helper.js